module.exports = __webpack_public_path__ + "img/avatar3.bb74b4e4.png";